import React from 'react'
import isAcceptableVolume from '../../StudentVolumeChecks/functions/isAcceptableVolume'
import isLoudVolume from '../../StudentVolumeChecks/functions/isLoudVolume'
import isSoftVolume from '../../StudentVolumeChecks/functions/isSoftVolume'

export default function VolumeMeterBar({ volumeStats, barCount, index}) {

    const red = `#ae0013`
    const green = `#7be638`

    let color = green // default low red zone
    let shouldDisplay = index < barCount

    if(volumeStats.maxVolume === -Infinity){
        shouldDisplay = false
    }

    if(!isAcceptableVolume(volumeStats)){
        color = red
    }
    if(isLoudVolume(volumeStats) || isSoftVolume(volumeStats)){
        color = red
    }

    return (
        <div style={{
            backgroundColor: color,
            visibility: shouldDisplay ? 'visible' : 'hidden'
        }} className={`volume-meter-bar v${index}`}></div>
    )
}
